/**
 * One time bucket in the salon dashboard usage series (matches each element of
 * `usages` returned from `DashboardQueryService.getSummary`).
 *
 * @typedef {Object} DashboardUsageBucket
 * @property {string} startDate - Bucket label (typically `YYYY-MM-DD`).
 * @property {Object} metrics
 * @property {number} metrics.sentStyleCount
 * @property {number} metrics.customerCount
 * @property {number} metrics.viewedStyleCount
 * @property {number} metrics.addedToCartCount
 * @property {number} metrics.purchaseCount
 * @property {number} metrics.salesAmount
 */

/**
 * Maps dashboard summary usage rows into parallel arrays for chart components.
 */
export default class UsageMapper {
  /**
   * Transforms chronological usage buckets into chart series (same index across arrays).
   *
   * @param {DashboardUsageBucket[]} usages
   * @returns {{
   *   labels: string[],
   *   sentStyleCounts: number[],
   *   viewedStyleCounts: number[],
   *   addedToCartCounts: number[],
   *   purchaseCounts: number[],
   *   salesAmounts: number[],
   * }}
   */
  static toChartData(usages) {
    const labels = [];
    const sentStyleCounts = [];
    const viewedStyleCounts = [];
    const addedToCartCounts = [];
    const purchaseCounts = [];
    const salesAmounts = [];

    usages.forEach(usage => {
      labels.push(new Date(usage.startDate).toLocaleDateString());
      sentStyleCounts.push(usage.metrics.sentStyleCount);
      viewedStyleCounts.push(usage.metrics.viewedStyleCount);
      addedToCartCounts.push(usage.metrics.addedToCartCount);
      purchaseCounts.push(usage.metrics.purchaseCount);
      salesAmounts.push(usage.metrics.salesAmount);
    });

    return {
      labels,
      sentStyleCounts,
      viewedStyleCounts,
      addedToCartCounts,
      purchaseCounts,
      salesAmounts,
    };
  }
}
